export class OpsTowerTODAs {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
    public VisibleBtnLoadMore: boolean = false;
}
